import moment from 'moment';
import { ID_CARD_REG, ID_STANDING_DATE } from '@/config';
import { IdataSource } from './type';

function flatArray(arr) {
  let arr1 = [];
  arr.forEach((val) => {
    if (val instanceof Array) {
      arr1 = arr1.concat(flatArray(val));
    } else {
      arr1.push(val);
    }
  });
  return arr1;
}

const isEmptyObject = (obj) => {
  if (Object.keys(obj || {}).length === 0) {
    return true;
  }
  return false;
};

const listToMap = (arr: Array<IdataSource>, key = 'value', value = 'label'): Object => {
  const res = {};
  arr.forEach((obj) => {
    res[obj[key]] = obj[value];
  });
  return res;
};

export const intlListToMap = (arr = []) => {
  return arr.reduce((obj, item) => {
    const descriptor = Object.getOwnPropertyDescriptor(item, 'label');
    Object.defineProperty(obj, item.value, {
      configurable: true,
      enumerable: true,
      get: descriptor.get,
    });
    return obj;
  }, {});
};

// 过滤表单为空参数
const filterFormParams = (values: any): Object => {
  const params = {};
  try {
    Object.keys(values)?.forEach((key) => {
      if (
        values[key] !== undefined &&
        values[key] !== null &&
        values[key] !== '' &&
        (!Array.isArray(values[key]) || values[key].length)
      ) {
        params[key] = values[key];
      }
    });
  } catch (error) {
    //
  }
  return params;
};

// 是否是长期证件
export const isStandingCardTime = (val) => {
  if (typeof val === 'string') {
    return val.replace(/\s/g, '') === '长期';
  }
  if (typeof val === 'number') {
    return val === ID_STANDING_DATE;
  }
  return false;
};

// 身份证额外信息参数转换（不包含姓名、证件号）
const transformCardInfo = (values) => {
  const { address, agency, birthdate, effecteddate, expireddate, nation, sex } = values || {};
  let sexFlag;
  if (sex === '男') sexFlag = 0;
  if (sex === '女') sexFlag = 1;
  let certificateEndTime;
  const parseCardTime = (val) => {
    if (val) {
      const date = moment.utc(val, 'YYYYMMDD');
      return date.isValid() ? date.subtract(8, 'hour').valueOf() : undefined;
    }
    return undefined;
  };
  if (isStandingCardTime(expireddate)) {
    certificateEndTime = ID_STANDING_DATE;
  } else {
    certificateEndTime = parseCardTime(expireddate);
  }
  const cardInfoParams = {
    certificateLocation: address,
    issuingAuthority: agency,
    birthday: parseCardTime(birthdate),
    certificateStartTime: parseCardTime(effecteddate),
    certificateEndTime,
    nation,
    sex: sexFlag,
  };
  return cardInfoParams;
};

// 是否成年人
const getIsAdult = async (certNo: number) => {
  const str = certNo?.toString();
  if (ID_CARD_REG.test(str)) {
    const isAdult = await new Promise((resolve) => {
      str.replace(/^\d{6}(\d{8})/, (matchVaue, groupValue) => {
        resolve(moment().isAfter(moment(groupValue).add(18, 'years')));
        return matchVaue;
      });
    });
    return isAdult;
  }
  // 非18位视为成年
  return true;
};

export { flatArray, isEmptyObject, listToMap, filterFormParams, transformCardInfo, getIsAdult };
